import { render, staticRenderFns } from "./SuperSlide.vue?vue&type=template&id=32b84b15&scoped=true"
import script from "./SuperSlide.vue?vue&type=script&lang=js"
export * from "./SuperSlide.vue?vue&type=script&lang=js"
import style0 from "./SuperSlide.vue?vue&type=style&index=0&id=32b84b15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b84b15",
  null
  
)

export default component.exports